'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ElectronLink = require('../../../../../components/electron/ElectronLink');

var _ElectronLink2 = _interopRequireDefault(_ElectronLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingTierPro = function BillingTierPro(props) {
    return _react2.default.createElement(
        'div',
        { className: 'BillingStatusDisplay BillingTierPro' },
        _react2.default.createElement(
            'div',
            { className: 'plan-status' },
            'You\'re on the\xA0',
            _react2.default.createElement(
                'span',
                { className: 'plan-name' },
                props.currentUser.getIn(['subscription', 'planName']),
                ' Plan'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'plan-storage' },
            'Unlimited storage'
        ),
        _react2.default.createElement(
            'div',
            { className: 'plan-actions' },
            _react2.default.createElement(
                _ElectronLink2.default,
                { to: '/account/plan', className: 'action' },
                'View billing details'
            )
        )
    );
};

BillingTierPro.propTypes = {
    currentUser: _propTypes2.default.object.isRequired
};

exports.default = BillingTierPro;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/billingStatus/BillingTierPro.js
// module id = 2172
// module chunks = 0